import { render, staticRenderFns } from "./ProfileView.vue?vue&type=template&id=1b55b053&scoped=true&"
import script from "./ProfileView.vue?vue&type=script&lang=ts&"
export * from "./ProfileView.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileView.vue?vue&type=style&index=0&id=1b55b053&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b55b053",
  null
  
)

export default component.exports